import { fetchFinance } from "utils/api";

export const queryList = async (params) => {
  return await fetchFinance("/settlement/list", {
    sort: "tran_date,desc",
    ...params,
  });
};

export const exportCsv = async (params) => {
  return await fetchFinance("/settlement/list", {
    output: "csv",
    ...params,
  });
};

export const changePlan = async (params) => {
  return await fetchFinance("/action", {
    action: "updateSettlePlan",
    ...params,
  });
};

export const changeAllPlan = async (params) => {
  return await fetchFinance("/action", {
    action: "updateAllSettlePlan",
    ...params,
  });
};

export const createForm = async (params) => {
  return await fetchFinance("/action", {
    action: "addSettlePlan",
    ...params,
  });
};
